export default __webpack_public_path__ + "static/media/sublevel3_5.57c19d16.webp";